// Cookie как реактивное значение (для варианта оформления A/B).
import { ref, watch, type Ref } from 'vue';

export function useCookie<T extends string = string>(name: string, options: { default?: () => T; maxAge?: number; sameSite?: 'lax' | 'strict' } = {}): Ref<T> {
  const found = document.cookie.split('; ').find(row => row.startsWith(`${name}=`));
  const value = ref((found ? decodeURIComponent(found.slice(name.length + 1)) : options.default?.()) as T) as Ref<T>;
  watch(value, next => {
    const parts = [`${name}=${encodeURIComponent(String(next ?? ''))}`, 'path=/', `samesite=${options.sameSite ?? 'lax'}`];
    if (options.maxAge) parts.push(`max-age=${options.maxAge}`);
    if (location.protocol === 'https:') parts.push('secure');
    document.cookie = parts.join('; ');
  }, { flush: 'sync' });
  return value;
}
